const menu = [
  {
    icon: 'box',
    label: 'All Snippets',
    value: 'all',
  },
  {
    icon: 'heart-empty',
    label: 'Favorite',
    value: 'favorite',
  },
];

export default menu;
